import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-item px-5\" data-kt-menu-trigger=\"hover\" data-kt-menu-placement=\"left-start\" data-kt-menu-flip=\"center, top\"><div class=\"menu-sub menu-sub-dropdown w-175px py-4\"><div class=\"separator my-2\"></div></div></div><div class=\"separator my-2\"></div><div class=\"menu-item px-5\" data-kt-menu-trigger=\"hover\" data-kt-menu-placement=\"left-start\" data-kt-menu-flip=\"center, top\"><div class=\"menu-sub menu-sub-dropdown w-175px py-4\"></div></div>", 3)
const _hoisted_12 = { class: "menu-item px-5 my-1" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Account Settings ")
const _hoisted_14 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Profile Image",
            src: _ctx.profileImage
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userInfo["name"]), 1),
          _createElementVNode("a", {
            href: `mailto:${_ctx.userInfo['email']}`,
            class: "fw-bold text-muted text-hover-primary fs-7 text-break"
          }, _toDisplayString(_ctx.userInfo["email"]), 9, _hoisted_8)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        to: { name: 'settings' },
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}